
$(document).ready(function(){
 
      $('body').on('click','.close_discount',function(){
    $(".discount_overlay").hide();
  });
 
   $('body').on('click','.coupon-popup',function(){
    $(".discount_overlay").show();
  });
  
    $('body').on('click','#applycoupon',function(){
       var val =  $('#coupon_code').val();
     applyDiscount(val);
    });

   $('body').on('click','.remove-coupon',function(){
   applyDiscount('coupons');
   });

  function  applyDiscount(val){
   let shopUrl =  window.location.href.split("/cart")[0];

    
  // let discountApplyUrl = `${shopUrl}${actionUrl}?discount=${val}`;
  // let discountApplyUrl = shopUrl + '/cart?discount='+ val; 
//     let discountApplyUrl = "/discount/"+val+"?v="+Date.now()+"&redirect=/checkout/";
    let discountApplyUrl = "/discount/"+val;
      console.log(discountApplyUrl);
    fetch(discountApplyUrl)
    .then(function(response) {
      console.log(response);
    if (!response.ok) {
    throw new Error('Failed to apply discount');
    }
    return response.text();
    })
    .then(function(data) {
     fetch(`${window.location.pathname}`)
.then((responsecart) => responsecart.text())
.then((datacart) => {
 var inhtml = new DOMParser().parseFromString(datacart, 'text/html').querySelector('cart-items').innerHTML;
  // console.log(new DOMParser().parseFromString(datacart, 'text/html').querySelector('cart-items'))
document.querySelector('cart-items').innerHTML = inhtml;
  $(".discount_overlay").hide();
});
    })
    .catch(function(error) {
    throw error;
    });
  }

  
});

